import type { SiteSectionId, V4HSiteId } from "@/data/common/ids";
import type { MaybeRef, Ref } from "vue";

const mutation = {
  api: "site-section",
  type: "mutation",
} as const;

export const SiteSectionMutationKeys = {
  create: (siteId: MaybeRef<V4HSiteId>) => [mutation, { action: "create-site-section", siteId }] as const,
  createCategory: (siteId: MaybeRef<V4HSiteId>) =>
    [mutation, { action: "create-site-section-category", siteId }] as const,
  updateCategory: (siteId: MaybeRef<V4HSiteId>) =>
    [mutation, { action: "update-site-section-category", siteId }] as const,
  deleteCategory: (siteId: MaybeRef<V4HSiteId>) =>
    [mutation, { action: "delete-site-section-category", siteId }] as const,
  updateSectionsCategories: (siteId: MaybeRef<V4HSiteId>) =>
    [mutation, { action: "update-sections-categories", siteId }] as const,
  delete: (siteId: Ref<V4HSiteId>, sectionId: MaybeRef<SiteSectionId>) =>
    [mutation, { action: "delete-site-section", siteId, sectionId }] as const,
  move: (sectionId: MaybeRef<SiteSectionId>) => [mutation, { action: "move-site-section", sectionId }] as const,
  patch: (sectionId: MaybeRef<SiteSectionId>) => [mutation, { action: "patch-site-section", sectionId }] as const,
};
